import { axiosGet } from "../../../react_axios/Axios";
import { CHECK_PENDING_PAYMENT, checkPendingPaymentUrl, GET_PAYMENT_LIST_ACTION_TYPE, getPaymentListUrl, headers } from "../../../utils/constants";



export const getPaymentList_action = () => async (dispatch) => {

    try {
        const params = {
            Userid: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getPaymentListUrl, params, headers)

        dispatch({
            type: GET_PAYMENT_LIST_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const checkPendingPayment_action = (ExhRegistrationID) => async (dispatch) => {

    try {
        const params = {
            Userid: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: ExhRegistrationID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(checkPendingPaymentUrl, params, headers)

        dispatch({
            type: CHECK_PENDING_PAYMENT,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}